import React, { useState,useEffect, useRef } from "react";
import apiUrl from "../../services/environment"
import {Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom';
import Logo from "../../assets/images/logo.svg"
import { toast } from 'react-toastify';
import Loader from '../Commons/Loader';
// import Cookies from 'js-cookie';
const OTP_LENGTH = 6; // Change this for different OTP lengths

const ForgotPassword = () => {
  // const accessToken = Cookies.get('accessToken');
  // const userEmail = Cookies.get('userEmail');
  const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(""));
  const inputRefs = useRef([]);
  const history = useHistory();
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(""); 
  const [errors, setErrors] = useState({});
  const [otpFrom, setotpFrom] = useState(false); 
  const [btnDis, setBtnDis] = useState(false); 
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;
    if (!formData.email) {
      tempErrors.email = "Please type email";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      tempErrors.email = "Please type a valid email";
      isValid = false;
    }
    setErrors(tempErrors);
    return isValid;
  };
  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // Handle backspace
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleChangeOtp = (e, index) => {
    const value = e.target.value;
    if (isNaN(value)) return; // Only allow numbers

    let newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1); // Ensure single digit
    setOtp(newOtp);

    // Move to next input
    if (value && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1].focus();
    }
  };
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  // Handle submission
  const handleSubmit = async (e) => {
    toast.dismiss();
    e.preventDefault();
    if (validate()) {
      setLoading(true);
        try {

            // Send credentials to the API for authentication
            const response = await fetch(apiUrl + "auth/reset-password", {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email
                }),
            });

            const data = await response.json();
          
            if(data.status.code===200){
                toast.success(data.status.message);
                //setSuccessMessage(data.status.message);
                
                setTimeout(() => {
                   
                    if (timer === 0) {
                      setTimer(data.data.nextOtpRetryAfter);
                  }
                }, 2000);
            }else{
               // setError(data.status.message);
                toast.error(data.status.message);
            }
            // setTimeout(() => {
            //     setSuccessMessage("");
            //     setError("");
            // }, 2000);
        } catch (err) {
            

        }finally {
          setotpFrom(true); 
          setLoading(false);
        }
    }
  };
  
  const handleResendOTP = async (e) => {
    toast.dismiss();
    setLoading(true);
    try {

        // Send credentials to the API for authentication
        const response = await fetch(apiUrl + "auth/reset-password-resend-otp", {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: formData.email
            }),
        });

        const data = await response.json();

        if(data.status.code===200){
            //setSuccessMessage(data.status.message);
            toast.success(data.status.message);
            setOtp(new Array(OTP_LENGTH).fill("")); 
            if (timer === 0) {
              setTimer(data.data.nextOtpRetryAfter);
            }
           
        }else{
            // setError(data.status.message);
            toast.error(data.status.message);
            if (timer === 0) {
              setTimer(data.data.nextOtpRetryAfter);
            }
        }
        // setTimeout(() => {
        //     setSuccessMessage("");
        //     setError("");
        // }, 3000);
    } catch (err) {
        

    }finally {
      setLoading(false);
    }
  }

  const handleOtpSubmit = async (e) => {
    toast.dismiss();
    setLoading(true);
    const otpValue = otp.join("");

    try {
        const response = await fetch(apiUrl + "auth/reset-password-validate-otp", {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: formData.email,
                otp: otpValue
            }),
        });
    //   const response = await axiosInstance.post('auth/reset-password-validate-otp', {
    //     otp: otpValue, // Send the OTP in the request body
    //   });
        const data = await response.json();
        console.log(data.status.message,"data.status.message")
        if(data.status.code===200){
            //setSuccessMessage(data.status.message);
            toast.success(data.status.message);
            setTimeout(() => {
                setOtp(new Array(OTP_LENGTH).fill("")); 
            }, 2000);
            setTimeout(() => {
              history.push('/login'); 
          }, 3000);
            // setTimeout(() => {
            //   setSuccessMessage("");
            //   setError("");
            // }, 4000);
        }else if(data.status.code===429){
          //setError(data.status.message);
          toast.error(data.status.message);
          setBtnDis(true);
            setTimeout(() => {
                history.push('/login'); 
            }, 3000);
            setTimeout(() => {
                setError("");
            }, 4000);
        }else{
            // setError(data.status.message);
            toast.error(data.status.message);
            // setTimeout(() => {
            //     setSuccessMessage("");
            //     setError("");
            // }, 3000);
        }
       
      // Clear the OTP input
      


    } catch (error) {
      console.log("kkk")
      
      console.error('Error validating OTP:', error);
    }finally {
      setLoading(false);
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    
    if (/^\d{6}$/.test(pastedData)) { // Ensure it's exactly 6 digits
      const newOtp = pastedData.split(""); // Convert string to array
      setOtp(newOtp);
      
      // Auto-focus next inputs
      newOtp.forEach((digit, index) => {
        if (inputRefs.current[index]) {
          inputRefs.current[index].value = digit;
          if (index < OTP_LENGTH - 1) {
            inputRefs.current[index + 1].focus();
          }
        }
      });
    }
  };
  const isDisabled = btnDis || otp.some((digit) => digit === "");
  return (
    <>
      {loading && <Loader />} 
      <div className='login-wrapper'>
        <div className="login-form otp-form forgot-password-page">
          <div className='login-left'>
            <img src={Logo} alt=""/>
          </div>
          <div className='login-right'>
              <h2>Reset Password</h2>
              {!otpFrom&&<form onSubmit={handleSubmit}>
                  <div>
                      <div className="form-group">
                          <label>Enter Your Email <span>*</span></label>
                          <input type="text" className="input-fld" name="email" value={formData.email} onChange={handleChange} />
                          {errors.email && <span className="error">{errors.email}</span>}
                      </div>
                      {error && <p style={{ color: 'red' }}>{error}</p>}
                      {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
                      <button type="submit">
                          Submit
                      </button>
                  </div>
                  
              </form>}
              {otpFrom && <div className="otp-container">
                  <label htmlFor="username">Enter OTP</label>
                  <p>{formData.email} <a className="edit-email" onClick={() => setotpFrom(false)}><i className="nav-icon fas fa-pencil-alt"></i></a></p>
                  <div className="otp-inputs">
                      
                      {otp.map((_, index) => (
                      <input
                          key={index}
                          type="tel"
                          maxLength="1"
                          value={otp[index]}
                          onChange={(e) => handleChangeOtp(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          onPaste={handlePaste}
                          ref={(el) => (inputRefs.current[index] = el)}
                      />
                      ))}
                  </div>
                  {/* <p>OTP has been successfully sent. 
                  It will be expire in 20 seconds</p> */}
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                  {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
                  <button onClick={handleOtpSubmit} disabled={isDisabled}>Verify OTP</button>
                  <br/>
                  <a onClick={handleResendOTP} className="resend-otp" disabled={timer > 0}>{timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}</a>
              </div>}
              <div>
                  <Link to="/login" className='btn-link'>Back To Login</Link>
              </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
